import {USER_PROFILE_ALLOCATIONS} from '@/constants/engine';
import {DocumentData} from '@/engine/types';
import {Allocation} from '@/repositories/beneva-api/endpoints/allocations';
import {mapAllocationTypeToDomainValue} from '@/utils/document/map-allocation-type-to-dv93';

export const getAllocationsAsDocumentData = (allocations: Allocation[] = []): DocumentData['data'] => {
  const properties: DocumentData['data'] = {};

  const mappedAllocations = allocations.map(allocation => ({
    ...allocation,
    accountType: mapAllocationTypeToDomainValue(allocation.accountType),
  }));

  properties[USER_PROFILE_ALLOCATIONS] = JSON.stringify(mappedAllocations);

  const options: string[] = [];
  allocations.forEach(allocation => {
    const allocationRef = `${USER_PROFILE_ALLOCATIONS}_${allocation.id}`;
    properties[allocationRef] = allocation.name;
    options.push(allocationRef);
  });

  properties[`_${USER_PROFILE_ALLOCATIONS}[count]`] = `${allocations.length}`;
  properties[`_${USER_PROFILE_ALLOCATIONS}[options]`] = JSON.stringify(options);

  return properties;
};
